import * as React from 'react';
import { useWebComponent } from 'components/WebComponentRoot';
import { captureElementSnapshot } from 'utils/ui/captureElementSnapshot';
import { getMicro2DAppCaptureTarget } from 'utils/ui/getMicro2DAppCaptureTarget';
import { IMicro2DAppElement } from 'components/Micro2DApp';

export function useCaptureComparisonImage(): () => Promise<Blob> {
  const { rootElement } = useWebComponent();

  return React.useCallback(async () => {
    const root: Document | ShadowRoot = rootElement ?? document;
    const el = root.querySelector<IMicro2DAppElement>('micro-2d-app');
    if (!el) {
      throw new Error('micro-2d-app element not found');
    }
    const target = getMicro2DAppCaptureTarget(el);
    return captureElementSnapshot(target);
  }, [rootElement]);
}
